import { gql } from '@apollo/client';

export const INCREMENT_COMPANY_SUBSCRIPTION_USAGE = gql`
  mutation IncrementCompanySubscriptionUsage($input: IncrementCompanySubscriptionUsageInput!) {
    incrementCompanySubscriptionUsage(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
    }
  }
`;
